import { useHistory } from "react-router-dom";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen los botones de la barra de navegación.
================================================================================ */
export default function MenuItems6() {
    let history = useHistory();
    const items = [
        {
            label: 'Pagar Pedidos',
            path: "/PayOrder",
            index: 0,
        }
    ]
    return items
}